// extracted by mini-css-extract-plugin
module.exports = {"container":"InputPreview_container__2Ft5R","label":"InputPreview_label__1qung","value":"InputPreview_value__2bm7v"};